export default {
  operatedBy: 'Drevet af',
  partlyOperatedBy: 'Delvist drevet af',
  operatedByGerman: '',
}
